// Auto-generated from BreakoutFactory.sol/BreakoutFactory.json
// Do not edit manually - run 'bun run generate:abi' to regenerate

export const breakoutMarketFactoryAbi = [
	{
		type: "constructor",
		inputs: [
			{
				name: "usdc_",
				type: "address",
				internalType: "address",
			},
			{
				name: "registry_",
				type: "address",
				internalType: "address",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "REGISTRY",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "address",
				internalType: "contract IBreakoutRegistry",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "USDC",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "address",
				internalType: "address",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "createMarket",
		inputs: [
			{
				name: "implementation",
				type: "address",
				internalType: "address",
			},
			{
				name: "salt",
				type: "bytes32",
				internalType: "bytes32",
			},
			{
				name: "reserve",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "initData",
				type: "bytes",
				internalType: "bytes",
			},
		],
		outputs: [
			{
				name: "market",
				type: "address",
				internalType: "address",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "multicall",
		inputs: [
			{
				name: "data",
				type: "bytes[]",
				internalType: "bytes[]",
			},
		],
		outputs: [
			{
				name: "",
				type: "bytes[]",
				internalType: "bytes[]",
			},
		],
		stateMutability: "payable",
	},
	{
		type: "function",
		name: "predictMarketAddress",
		inputs: [
			{
				name: "implementation",
				type: "address",
				internalType: "address",
			},
			{
				name: "salt",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		outputs: [
			{
				name: "",
				type: "address",
				internalType: "address",
			},
		],
		stateMutability: "view",
	},
	{
		type: "event",
		name: "MarketCreated",
		inputs: [
			{
				name: "salt",
				type: "bytes32",
				indexed: true,
				internalType: "bytes32",
			},
			{
				name: "market",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "implementation",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "reserve",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "error",
		name: "InitializationFailed",
		inputs: [
			{
				name: "reason",
				type: "bytes",
				internalType: "bytes",
			},
		],
	},
	{
		type: "error",
		name: "InvalidImplementation",
		inputs: [],
	},
	{
		type: "error",
		name: "Unauthorized",
		inputs: [],
	},
] as const
